import { render, staticRenderFns } from "./onlineTraining.vue?vue&type=template&id=a0c9adb0&scoped=true&"
import script from "./onlineTraining.vue?vue&type=script&lang=js&"
export * from "./onlineTraining.vue?vue&type=script&lang=js&"
import style0 from "./onlineTraining.vue?vue&type=style&index=0&id=a0c9adb0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0c9adb0",
  null
  
)

export default component.exports